/* eslint-disable consistent-return */
/* eslint-disable react-hooks/exhaustive-deps */
import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import IconClock2 from "../../../../../public/assets/icons/IconClock2";
import { formatTime } from "../../../../utils/helpers/helpers";

function FormatTimePractice({
  isIpad,
  time
}: any) {
  const [times, setTime] = useState(time);
  useEffect(() => {
    const interval = setInterval(() => {
      setTime(times + 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [times]);

  return (
    <Box className="center-col" style={{ marginBottom: isIpad ? 0 : 12 }}>
      <Box
        className="center-row"
        style={{
          fontSize: 14
        }}
      >
        {isIpad && <IconClock2 />}
        <span
          className={`${isIpad ? "text-[13px]" : "text-[23px]"}`}
          style={{
            marginLeft: 8
          }}
        >
          {formatTime(times)}
        </span>
      </Box>
    </Box>
  );
}

export default FormatTimePractice;
